/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export enum Key {
  Uninitialized,
  StakePool,
  StakeAccount,
  ProgramAuthority,
}

export type KeyArgs = Key;

export function getKeyEncoder(): FixedSizeEncoder<KeyArgs> {
  return getEnumEncoder(Key);
}

export function getKeyDecoder(): FixedSizeDecoder<Key> {
  return getEnumDecoder(Key);
}

export function getKeyCodec(): FixedSizeCodec<KeyArgs, Key> {
  return combineCodec(getKeyEncoder(), getKeyDecoder());
}
